var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"floating-back-button",on:{"click":_vm.onClick}},[_c('i',{staticClass:"material-icons"},[_vm._v("chevron_left")])])}
var staticRenderFns = []

export { render, staticRenderFns }